import { ArticleType } from '@wix/answers-api';
import React, { FC, useCallback, useEffect, useState } from 'react';

import {
  getVoteStatus,
  unvote,
  vote,
} from '../../../common/api/voteForArticle';
import { HelpCenterVoteableArticle } from '../../types';
import { FeatureRequestVoteButton } from './FeatureRequestVoteButton';
import { KnownIssueVoteButton } from './KnownIssueVoteButton';

export interface ArticleVoteButtonProps {
  article: HelpCenterVoteableArticle;
}

export const ArticleVoteButton: FC<ArticleVoteButtonProps> = ({ article }) => {
  const [isVoted, setIsVoted] = useState<boolean>();
  const [
    isVotedInCurrentSession,
    setIsVotedInCurrentSession,
  ] = useState<boolean>(false);

  useEffect(() => {
    const fetchVoteStatus = async () => {
      const currentStatus = await getVoteStatus(article.id);
      setIsVoted(currentStatus);
    };

    fetchVoteStatus();
  }, [article]);

  const onVote = useCallback(() => {
    const voted = !isVoted;

    if (voted) {
      vote(article.id);
    } else {
      unvote(article.id);
    }

    setIsVoted(voted);
    setIsVotedInCurrentSession(voted);
  }, [article, isVoted, setIsVoted]);

  if (isVoted === undefined) {
    return null;
  }

  return (
    <>
      {article.type === ArticleType.FEATURE_REQUEST ? (
        <FeatureRequestVoteButton
          article={article}
          onVote={onVote}
          isVoted={isVoted}
          isVotedInCurrentSession={isVotedInCurrentSession}
        />
      ) : null}
      {article.type === ArticleType.KNOWN_ISSUE ? (
        <KnownIssueVoteButton
          article={article}
          onVote={onVote}
          isVoted={isVoted}
          isVotedInCurrentSession={isVotedInCurrentSession}
        />
      ) : null}
    </>
  );
};
